exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.map[data-v-52eac35c]{\r\n    width:100%;\r\n    height:270px;\n}\n.loader[data-v-52eac35c]{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    background:  rgb(255, 255, 255);\n}\n.none[data-v-52eac35c]{\r\n    display: none;\n}\n.btgreen[data-v-52eac35c]{\r\n    background-color: #77ba82;\r\n    color: #ffffff;\n}\ntable[data-v-52eac35c]{\r\n    width:100%;\r\n    margin-bottom:20px\n}\ntd[data-v-52eac35c]{\r\n    padding:10px;    \r\n    background:#f2f2f2\n}\nth[data-v-52eac35c]{\r\n    background-color: #f9f301;\r\n    font-weight: bold;\r\n    padding:10px;\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-52eac35c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/about/about-company.vue
// module id = 587
// module chunks = 0